import React from "react";
import { Modal, ModalContent } from "./ModalsStyled";

const GenericModal = ({ open, handleClose, children }) => (
  <Modal open={open} onClose={handleClose}>
    <ModalContent>{children}</ModalContent>
  </Modal>
);

export default GenericModal;
